<template>
  <div class="publicidad-overlay">
    <LanzamientoDialog v-if="lanzamientoAbierto && lanzamiento" :campania="lanzamiento" @cerrado="lanzamientoAbierto = false" />
    <BarraPos v-if="mostrarBarraPos" :campania="barraPos" />
  </div>
</template>

<script>
import LanzamientoDialog from "./LanzamientoDialog.vue";
import BarraPos from "./BarraPos.vue";

const RUTA_INICIO = "Inicio";
const RUTA_POS = "pos";

/**
 * Único punto de montaje global de la publicidad de la plataforma (App.vue).
 * Carga las campañas al iniciar sesión y decide qué se ve según la ruta:
 * - la ventana de lanzamiento solo en el Inicio y una sola vez por carga de la app
 *   (la bandera del store es la compuerta; `lanzamientoAbierto` es local y pegajosa:
 *   marcar la compuerta no cierra la ventana ya abierta);
 * - en el POS, nada más que la barra discreta (nunca sobre una venta).
 * El banner del Inicio, la tarjeta del menú y la novedad de la campana se montan en
 * sus propios lugares y leen el mismo store.
 */
export default {
  name: "PublicidadOverlay",
  components: { LanzamientoDialog, BarraPos },
  data() {
    return { lanzamientoAbierto: false };
  },
  computed: {
    logueado() {
      return Boolean(this.$store.getters.loginState);
    },
    porTipo() {
      return this.$store.getters["publicidad/porTipo"] || {};
    },
    lanzamiento() {
      return this.porTipo.lanzamiento || null;
    },
    barraPos() {
      return this.porTipo.pos || null;
    },
    enInicio() {
      return this.$route && this.$route.name === RUTA_INICIO;
    },
    enPos() {
      return this.$route && this.$route.name === RUTA_POS;
    },
    // Compuerta: hay campaña, estamos en el Inicio y todavía no se mostró en esta carga
    puedeAbrirLanzamiento() {
      return this.enInicio && Boolean(this.lanzamiento) && !this.$store.state.publicidad.lanzamientoMostrado;
    },
    mostrarBarraPos() {
      return this.enPos && Boolean(this.barraPos);
    },
  },
  watch: {
    logueado(valor) {
      if (valor) this.cargar();
    },
    puedeAbrirLanzamiento: {
      immediate: true,
      handler(puede) {
        if (!puede) return;
        this.lanzamientoAbierto = true;
        this.$store.commit("publicidad/SET_LANZAMIENTO_MOSTRADO", true);
      },
    },
    // Si la campaña desaparece del store (cerrada / no mostrar), la ventana se va
    lanzamiento(campania) {
      if (!campania) this.lanzamientoAbierto = false;
    },
  },
  created() {
    if (this.logueado) this.cargar();
  },
  methods: {
    cargar() {
      this.$store.dispatch("publicidad/cargar");
    },
  },
};
</script>
